import { render, staticRenderFns } from "./suggestionEntryMetadata.vue.html?vue&type=template&id=73d623b4&"
import script from "./suggestionEntryMetadata.ts?vue&type=script&lang=ts&"
export * from "./suggestionEntryMetadata.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports